/**
 * Tabelmaten uit het designsysteem, op één plek.
 *
 * Waarom niet de DataTable-component zelf: die verwacht kolommen en rijen als data en
 * rendert de cellen zelf. De schermen in deze app hebben per rij eigen knoppen, links en
 * data-testid's die de tests gebruiken; die zouden bij een omzetting sneuvelen, en dat is
 * herbouw in plaats van restyling. Daarom nemen we de máten over — precies de waarden uit
 * `components/DataTable.jsx` van de levering — en houden we de tabellen zelf.
 *
 * Wijzigt het designsysteem, dan is dit het enige bestand dat mee moet.
 */

/** Kolomkop: kleinkapitaal, 11px, ruime letterafstand. */
export const TH = {
  textAlign: "left",
  padding: "var(--ruimte-5) var(--ruimte-6)",
  fontSize: 11,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  fontWeight: "var(--fw-semi)",
  color: "var(--text-soft)",
  borderBottom: "1px solid var(--border-subtle)",
  whiteSpace: "nowrap",
  background: "var(--surface-sunken)",
};

/** Cel: 12px boven/onder, 16px opzij. */
export const TD = {
  padding: "var(--ruimte-6)",
  color: "var(--text-body)",
  verticalAlign: "middle",
};

/** Rijscheiding: onderlangs, zodat er geen dubbele lijn onder de kolomkoppen staat. */
export const RIJ = { borderBottom: "1px solid var(--neutraal-100)" };

/** Omhulsel: wit vlak met dunne rand en de kaartschaduw. */
export const TABELVLAK = {
  overflowX: "auto",
  background: "var(--wit)",
  border: "1px solid var(--border-subtle)",
  borderRadius: "var(--radius-vlak)",
  boxShadow: "var(--elevation-card)",
};

/** Gegroepeerde tabellen (Werknemers per werkgever) tekent het ontwerp lichter:
    geen ingezonken kopbalk, kolomkoppen 12px/500. */
export const TH_GROEP = {
  textAlign: "left",
  padding: "var(--ruimte-4) var(--ruimte-6)",
  fontSize: "var(--fs-xs)",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  fontWeight: "var(--fw-medium)",
  color: "var(--text-soft)",
  borderBottom: "1px solid var(--border-subtle)",
  whiteSpace: "nowrap",
  background: "transparent",
};

export const TD_GROEP = { padding: "var(--ruimte-5) var(--ruimte-6)", color: "var(--text-body)" };

export const TABEL = { width: "100%", borderCollapse: "collapse", fontSize: "var(--fs-body)" };

/** Detaillink in de laatste kolom: 12px, halfvet, in de actiekleur. */
export const RIJLINK = {
  fontSize: "var(--fs-xs)",
  fontWeight: "var(--fw-semi)",
  color: "var(--text-action)",
};
